export interface DimensionMetadataDetail {
  sid: number;
  name: string;
  parentSid: number;
  level: number;
  groupType: string;

  [detail: string]: number | string | number[] | string[];
}

export class DimensionMetadata {
  nameId: string;
  details: DimensionMetadataDetail[];

  constructor(
    nameId: string,
    details: DimensionMetadataDetail[]
  ) {
    this.nameId = nameId;
    this.details = details;
  }
}